import { render } from "./SiteFooter.vue?vue&type=template&id=7d9bd85d&scoped=true&ts=true"
import script from "./SiteFooter.vue?vue&type=script&lang=ts"
export * from "./SiteFooter.vue?vue&type=script&lang=ts"

import "./SiteFooter.vue?vue&type=style&index=0&id=7d9bd85d&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d9bd85d"]])

export default __exports__